import { render, staticRenderFns } from "./DashboardTableCard.vue?vue&type=template&id=81f6ce0a&scoped=true&"
import script from "./DashboardTableCard.vue?vue&type=script&lang=js&"
export * from "./DashboardTableCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTableCard.vue?vue&type=style&index=0&id=81f6ce0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f6ce0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
